import appConstants from '../../../../../appConstants';
import { BUTTON_LABELS } from './constants';

/**
 * Utility functions for ETL Summary - Shipment Selection to Optimization
 * @see docs/features/SHIPMENT_SELECTION_TO_OPTIMIZATION.md
 */

export const isPathInIBPlanning = (pathname) =>
  pathname?.toLowerCase?.().includes(appConstants.NAV_URLS.IBPLANNING_HOME);

export const getButtonLabel = ({ isEnforcedDynamicRoutingEnabled, cityRoutes, isLoading }) => {
  if (isLoading) return null;
  if (isEnforcedDynamicRoutingEnabled && cityRoutes?.length > 0) return BUTTON_LABELS.CREATE_ROUTES;
  return BUTTON_LABELS.VIEW_PLAN;
};

export const shouldNavigateWithCityRoutes = (isEnforcedDynamicRoutingEnabled, cityRoutes) => {
  return isEnforcedDynamicRoutingEnabled && cityRoutes?.length > 0;
};
